export default function styleSynthesizer(cssModule, componentName) {
  return (...classNames) => {
    return classNames.reduce((names, name) => {
      const styles = names.concat(`${cssModule[name] ? cssModule[name] : ''} ${componentName}--${name} `)
      return styles
    }, '')
  }
}
